interface CheckPhoneIsValidParams {
  phone: string;
  invalid?: boolean;
}

export const checkPhoneIsValid = ({ phone, invalid }: CheckPhoneIsValidParams) => {
  return !invalid && phone.length === 18;
};
